module.exports = __webpack_public_path__ + "static/media/twitter_grey_icon.eee58cd4.png";